import {Link} from 'react-router-dom'

const LinkButtonBig = (props) => {
    return (
        <Link to={props.destination} className={`flex justify-center items-center w-full p-2 mt-4 font-semibold ${props?.addClass ?? ''}`}>{props.title}</Link>
    )
}

export default LinkButtonBig;
